import { Beneficiary } from 'types';
import invitationStatus from 'constants/invitationStatus';

export const isBeneficiaryPendingOfSignInvitation = (
  beneficiary: Beneficiary
): boolean => {
  // Early return for invalid beneficiary
  if (!beneficiary) return false;

  // Check if beneficiary is not a draft
  const isNotDraft = beneficiary.isDraft !== true;

  // Check if invitation status is pending
  const isPendingInvitation =
    beneficiary.invitationStatus === invitationStatus.PENDING.value;

  // Check if beneficiary is eligible (not canceled OR canceled but has units)
  const isEligible =
    !beneficiary.isCanceled ||
    (beneficiary.isCanceled && (beneficiary.finalConsolidatedUnits ?? 0) > 0);

  return isNotDraft && isPendingInvitation && isEligible;
};
